import Nullstack from 'nullstack';
export default function IconBrandStackoverflow({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-brand-stackoverflow",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M4 17v1a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-1"
  }), "   ", Nullstack.element("path", {
    d: "M8 16h8"
  }), "   ", Nullstack.element("path", {
    d: "M8.322 12.582l7.956 .836"
  }), "   ", Nullstack.element("path", {
    d: "M8.787 9.168l7.826 1.664"
  }), "   ", Nullstack.element("path", {
    d: "M10.096 5.764l7.608 2.472"
  }), " ");
}